import { checkMonth } from './verifyFuncs/monthVerify';
import { checkYear } from './verifyFuncs/yearVerify';
import {
  checkBirthdayDays,
  checkBirthdayMonth,
  checkBirthdayYear,
} from './verifyFuncs/birthdayVerify';
import isMobilePhone from 'validator/lib/isMobilePhone';
// import isStrongPassword from 'validator/lib/isStrongPassword';
import i18n from '@/i18n/index';

// 存储旧的表单数据/上一个formData
let oldFormData = {};

export default function (formData) {
  return new Promise(resolve => {
    oldFormData = { ...oldFormData, ...formData };

    const errorMsgArr = [];
    // email校验
    if (formData.username === '') {
      errorMsgArr.push({
        pass: false,
        part: 'all',
        name: 'username',
        // errMessage: 'Please enter your email address',
        errMessage: i18n.t('error-enter-email'),
      });
    } else if (
      formData.username &&
      !emailReg.test(formData.username) &&
      !numberReg.test(formData.username)
    ) {
      // 是否为正确的email地址，或者是否为纯数字
      errorMsgArr.push({
        pass: false,
        part: 'eml',
        name: 'username',
        // errMessage: 'Please enter a valid email address',
        errMessage: i18n.t('error-valid-email'),
      });
    }
    // 验证码
    if (formData.verificationCode === '') {
      errorMsgArr.push({
        pass: false,
        name: 'verificationCode',
        // errMessage: 'Please enter verification code.',
        errMessage: i18n.t('error-valid-verification-code'),
      });
    } else if (
      formData.verificationCode !== undefined &&
      formData.verificationCode !== null &&
      !numberReg.test(formData.verificationCode)
    ) {
      // 这里只做了数字的校验，没做位数的校验
      errorMsgArr.push({
        pass: false,
        name: 'verificationCode',
        // errMessage: 'The code is invalid.',
        errMessage: i18n.t('error-code-invalid'),
      });
    }
    // 旧密码
    if (formData.oldPassword === '') {
      errorMsgArr.push({
        pass: false,
        name: 'oldPassword',
        // errMessage: 'This field is required.',
        errMessage: i18n.t('error-field-required'),
      });
    }
    // 密码
    if (formData.password === '') {
      errorMsgArr.push({
        pass: false,
        name: 'password',
        // errMessage: 'This field is required.',
        errMessage: i18n.t('error-field-required'),
      });
    } else if (formData.password && !formData.password.match(passwordReg)) {
      errorMsgArr.push({
        pass: false,
        name: 'password',
        // errMessage:
        //   'Passwords must have at least 8 characters, contain 1 uppercase, 1 lowercase and 1 number.',
        errMessage: i18n.t('error-passwords-rule'),
      });
    }
    // 确认密码
    if (formData.confirmPassword === '') {
      errorMsgArr.push({
        pass: false,
        name: 'confirmPassword',
        // errMessage: 'This field is required.',
        errMessage: i18n.t('error-field-required'),
      });
    } else if (
      formData.confirmPassword &&
      oldFormData.password &&
      formData.confirmPassword !== oldFormData.password
    ) {
      // errorMsgArr.push({
      //   pass: false,
      //   name: 'password',
      //   errMessage: '',
      // });
      errorMsgArr.push({
        pass: false,
        name: 'confirmPassword',
        // errMessage: 'Passwords do not match. Please try again.',
        errMessage: i18n.t('error-passwords-not-match'),
      });
    }
    // 姓名
    if (formData.fname === '') {
      errorMsgArr.push({
        pass: false,
        name: 'fname',
        // errMessage: 'This field is required.',
        errMessage: i18n.t('error-field-required'),
      });
    } else if (formData.fname && !formData.fname.match(nameReg)) {
      errorMsgArr.push({
        pass: false,
        name: 'fname',
        // errMessage: 'Please use Latin alphabet characters only.',
        errMessage: i18n.t('error-name-rule'),
      });
    }
    if (formData.lname === '') {
      errorMsgArr.push({
        pass: false,
        name: 'lname',
        // errMessage: 'This field is required.',
        errMessage: i18n.t('error-field-required'),
      });
    } else if (formData.lname && !formData.lname.match(nameReg)) {
      errorMsgArr.push({
        pass: false,
        name: 'lname',
        // errMessage: 'Please use Latin alphabet characters only.',
        errMessage: i18n.t('error-name-rule'),
      });
    }
    // 生日日期校验
    if (formData.birthday === '') {
      errorMsgArr.push({
        pass: false,
        name: 'birthday',
        // errMessage: 'This field is required.',
        errMessage: i18n.t('error-field-required'),
      });
    } else if (formData.birthday && formData.birthday.length < 10) {
      errorMsgArr.push({
        pass: false,
        name: 'birthday',
        // errMessage: 'Check your expiration date.',
        errMessage: i18n.t('error-date'),
      });
    } else if (formData.birthday && checkBirthdayDays(formData.birthday)) {
      errorMsgArr.push({
        pass: false,
        name: 'birthday',
        // errMessage: 'Check your expiration date.',
        errMessage: i18n.t('error-date'),
      });
    } else if (formData.birthday && checkBirthdayMonth(formData.birthday)) {
      errorMsgArr.push({
        pass: false,
        name: 'birthday',
        // errMessage: 'Check your expiration date.',
        errMessage: i18n.t('error-date'),
      });
    } else if (formData.birthday && checkBirthdayYear(formData.birthday)) {
      errorMsgArr.push({
        pass: false,
        name: 'birthday',
        // errMessage: 'Your age is less than 18 years old. Please check the details.',
        errMessage: i18n.t('error-check-age'),
      });
    }
    // 区域编码
    if (formData.areaCode === '') {
      errorMsgArr.push({
        pass: false,
        name: 'areaCode',
        // errMessage: 'This field is required.',
        errMessage: i18n.t('error-field-required'),
      });
    }
    // 电子邮件
    if (formData.email === '') {
      errorMsgArr.push({
        pass: false,
        name: 'email',
        // errMessage: 'This field is required.',
        errMessage: i18n.t('error-field-required'),
      });
    } else if (formData.email && !emailReg.test(formData.email)) {
      errorMsgArr.push({
        pass: false,
        name: 'email',
        // errMessage: 'Please enter a valid email address.',
        errMessage: i18n.t('error-valid-email'),
      });
    }
    // 确认电子邮件
    if (formData.confirmEmail === '') {
      errorMsgArr.push({
        pass: false,
        name: 'confirmEmail',
        // errMessage: 'This field is required.',
        errMessage: i18n.t('error-field-required'),
      });
    } else if (
      formData.confirmEmail &&
      oldFormData.email &&
      oldFormData.email.toLowerCase() !== formData.confirmEmail.toLowerCase()
    ) {
      errorMsgArr.push({
        pass: false,
        name: 'email',
        errMessage: '',
      });
      errorMsgArr.push({
        pass: false,
        name: 'confirmEmail',
        // errMessage: 'Email addresses do not match.',
        errMessage: i18n.t('error-email-addresses-not-match'),
      });
    }
    // 卡号名字
    if (formData.visaCardName === '') {
      errorMsgArr.push({
        pass: false,
        name: 'visaCardName',
        // errMessage: 'This field is required.',
        errMessage: i18n.t('error-field-required'),
      });
    } else if (formData.visaCardName && formData.visaCardName.length < 2) {
      errorMsgArr.push({
        pass: false,
        name: 'visaCardName',
        // errMessage: 'Character number must be more than one.',
        errMessage: i18n.t('error-number-count'),
      });
      // } else if (formData.visaCardName && !formData.visaCardName.match(nameReg)) {
    } else if (formData.visaCardName && !nameReg.test(formData.visaCardName)) {
      errorMsgArr.push({
        pass: false,
        name: 'visaCardName',
        // errMessage: 'Please use Latin alphabet characters only.',
        errMessage: i18n.t('error-name-rule'),
      });
    }
    // 卡号
    if (formData.visaCardNum === '') {
      errorMsgArr.push({
        pass: false,
        name: 'visaCardNum',
        // errMessage: 'This field is required.',
        errMessage: i18n.t('error-field-required'),
      });
    } else if (formData.visaCardNum && formData.visaCardNum.length < 16) {
      errorMsgArr.push({
        pass: false,
        name: 'visaCardNum',
        // errMessage: 'Please enter the complete Visa Card number.',
        errMessage: i18n.t('error-card-number'),
      });
    }
    // 截止日期
    if (formData.cardExpiryDate === '') {
      errorMsgArr.push({
        pass: false,
        name: 'cardExpiryDate',
        errMessage: i18n.t('error-field-required'),
      });
    } else if (formData.cardExpiryDate && formData.cardExpiryDate.length < 5) {
      errorMsgArr.push({
        pass: false,
        name: 'cardExpiryDate',
        // errMessage: 'Check your expiration date.',
        errMessage: i18n.t('error-check-expiration-date'),
      });
    } else if (formData.cardExpiryDate && checkMonth(formData.cardExpiryDate)) {
      errorMsgArr.push({
        pass: false,
        name: 'cardExpiryDate',
        // errMessage: 'Check your expiration date.',
        errMessage: i18n.t('error-check-expiration-date'),
      });
    } else if (formData.cardExpiryDate && checkYear(formData.cardExpiryDate)) {
      errorMsgArr.push({
        pass: false,
        name: 'cardExpiryDate',
        // errMessage: 'Check your expiration date.',
        errMessage: i18n.t('error-check-expiration-date'),
      });
    }
    // CVV
    if (formData.cardNum === '') {
      errorMsgArr.push({
        pass: false,
        name: 'cardNum',
        // errMessage: 'This field is required.',
        errMessage: i18n.t('error-field-required'),
      });
    } else if (formData.cardNum && formData.cardNum.length < 3) {
      errorMsgArr.push({
        pass: false,
        name: 'cardNum',
        errMessage: i18n.t('error-cvv-rule'),
      });
    }
    // 电话号码校验
    if (formData.mobileNumber === '') {
      errorMsgArr.push({
        pass: false,
        name: 'mobileNumber',
        // errMessage: 'This field is required.',
        errMessage: i18n.t('error-field-required'),
      });
    } else if (formData.mobileNumber && !isMobilePhone(formData?.mobileNumber)) {
      errorMsgArr.push({
        pass: false,
        name: 'mobileNumber',
        // errMessage: 'Please fill in correct mobile number format.',
        errMessage: i18n.t('error-mobile'),
      });
    } else if (
      formData.mobileNumber &&
      formData.phone &&
      (formData.phone.length <= 7 || formData.phone.length >= 15)
    ) {
      errorMsgArr.push({
        pass: false,
        name: 'mobileNumber',
        // errMessage: 'Please fill in correct mobile number format.',
        errMessage: i18n.t('error-mobile'),
      });
    }

    if (errorMsgArr.length) {
      resolve(errorMsgArr);
    } else {
      resolve({ pass: true });
    }
  });
}

// 邮箱校验规则
const emailReg =
  /^[a-zA-Z0-9+._%-]{1,256}@[a-zA-Z0-9][a-zA-Z0-9-]{0,64}(\.[a-zA-Z0-9][a-zA-Z0-9-]{1,25})+$/;
// 手机号码校验
// const phoneReg = /^1(3|4|5|6|7|8|9)\d{9}$/;
// 密码校验(至少八个字符,至少一个大写字母,一个小写字母,一个数字和一个特殊字符)
// const passwordReg = /^(?=.*[a-zà-ÿ])(?=.*[A-ZÀ-Ÿ])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
// const passwordReg =
//   /^(?=.*([a-záàâäæçéèêëíîïñóôœúùûüö]))(?=.*([A-ZÁÀÂÄÆÇÉÈÊËÍÎÏÑÓÔŒÙÛÜÖ]))(?=.*\d)(?=.*[!#$%&*,.:;?@\[\]^_{|}+=¡¿~])[A-záàâäæçéèêëíîïñóôœúùûüöÁÀÂÄÆÇÉÈÊËÍÎÏÑÓÔŒÙÛÜÖ\d!#$%&*,.:;?@\[\]^_{|}+=¡¿~]{8,}$/;
const passwordReg =
  /^(?=.*[0-9])(?=.*[a-záàâäãæçéèêëíîïñóôõœúùûüö])(?=.*[A-ZÁÀÂÄÃÆÇÉÈÊËÍÎÏÑÓÔÕŒÚÙÛÜÖ])(?=.*[!#$%&*,.:;?@[\]^_{|}+=¡¿~<>/'"\-\\()«»¢£¤¥§©¬®¯°±²³´`µ¶·¸¹º¼½¾×÷])[\S]{8,}$/;

// 数字校验
const numberReg = /^[0-9]*$/;
// 姓名正则校验
const nameReg = /^[A-Za-zªºÀ-ÖØ-öø-ÿĀ-ſƒƠ-ơƯ-ưǍ-ǿȘșȚțẠ-ỹ\-'./^ÆÇÐØÞßŒ ]+$/;
